import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitize',
  standalone: true,
})
export class SanitizePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string | Node): SafeHtml {
    // While allowing iframes is not best practice, a lot of embedded content relies on them. This does allow a
    // potentially malicious actor to inject what appears to be an element of business centre for a social
    // engineering attack, but the browser should prevent any XSS attacks.
    return this.sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(value, { ADD_TAGS: ['iframe'] }));
  }
}

export interface TermsOfServiceData {
  termsOfService: string;
  accepted: boolean;
  partner?: TermsOfServiceDataPartner;
}

export interface TermsOfServiceDataPartner {
  name: string;
}

@Component({
  selector: 'inbox-terms-of-service',
  templateUrl: './inbox-terms-of-service.component.html',
  styleUrls: ['./inbox-terms-of-service.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    FormsModule,
    SanitizePipe,
  ],
})
export class InboxTermsOfServiceDialogComponent implements OnInit {
  checkedTerms = false;
  showFullTOS = false;
  constructor(
    public dialogRef: MatDialogRef<InboxTermsOfServiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TermsOfServiceData,
  ) {}

  ngOnInit(): void {
    this.data.accepted = false;
    if (this.data?.partner) {
      this.data.termsOfService = this.replaceVariables(this.data?.termsOfService);
    }

    this.data.termsOfService = this.convertToHtml(this.data?.termsOfService);
  }

  toggleTOS() {
    this.showFullTOS = !this.showFullTOS;
  }

  convertToHtml(escapeString: string): string {
    const parser = new DOMParser();
    return parser.parseFromString(parser.parseFromString(escapeString, 'text/html').body.textContent, 'text/html').body
      .textContent;
  }

  accepts(value: boolean): void {
    this.data.accepted = value;
    this.close();
  }

  replaceVariables(termsOfService: string): string {
    return termsOfService.replace(/\[\[partnerName\]\]/gm, this.data?.partner?.name);
  }

  close(): void {
    this.dialogRef.close(this.data);
  }
}
